module.exports = __webpack_public_path__ + "img/info-icon.6dd0d359.svg";